module.exports = __webpack_public_path__ + "img/settings.99ee0123.png";